import React from "react";

function AboutQuestionAnswer({ content }) {
    return <p className="about__question--answer">{content}</p>;
}

export default AboutQuestionAnswer;
